import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToastService, Toast } from "@services/toast/toast.service";
import { Observable } from "rxjs";
import { ToastComponent } from "../toast/toast.component";

@Component({
  selector: "app-toast-container",
  standalone: true,
  imports: [CommonModule, ToastComponent],
  templateUrl: "./toast-container.component.html",
  styleUrls: ["./toast-container.component.css"],
})
export class ToastContainerComponent {
  toasts$: Observable<Toast[]>;

  constructor(private toastService: ToastService) {
    this.toasts$ = this.toastService.toasts$;
  }

  removeToast(id: number) {
    this.toastService.remove(id);
  }
}
